"use client";

import { useTranslation } from "react-i18next";

import { ScrollArea } from "@/components/ui/scroll-area.tsx";
import { usePublicProfileStore } from "@/features/profile/public/store/usePublicProfileStore";
import { PublicHeaderDisplay } from "@/features/profile/public/components/PublicHeaderDisplay";
import { PublicAboutDisplay } from "@/features/profile/public/components/PublicAboutDisplay";
import { PublicEducationDisplay } from "@/features/profile/public/components/PublicEducationDisplay";
import { PublicCertificatesDisplay } from "@/features/profile/public/components/PublicCertificatesDisplay";
import { PublicSubjectsDisplay } from "@/features/profile/public/components/PublicSubjectsDisplay";
import { PublicLanguagesDisplay } from "@/features/profile/public/components/PublicLanguagesDisplay";
import PublicYoutubePreview from "@/features/profile/public/components/PublicYoutubePreview";
import { PublicLanguageSwitcher } from "@/features/profile/public/components/PublicLanguageSwitcher";
import { PublicReviewsPreview } from "@/features/profile/public/components/PublicReviewsPreview.tsx";
import ProfileLoader from "@/wrappers/GetProfileDataWrapper/ProfileLoader.tsx";

export default function PublicProfilePage() {
  const { profileData: data, isLoading } = usePublicProfileStore();
  const { t } = useTranslation("profile");

  if (isLoading) return <ProfileLoader />;
  if (!data) return <title>{`${t("profilePage")} - Ximly`}</title>;

  return (
    <ScrollArea className="h-[calc(100dvh_-_4rem)]">
      <title>{`${data.header_section.name} - Ximly`}</title>
      <div className="bg-background flex min-h-dvh flex-col items-center justify-center gap-4 space-y-6 px-1 sm:px-8 xl:flex-row xl:items-start">
        <div className="w-full space-y-6 lg:w-[50rem]">
          <PublicHeaderDisplay />
          <div className="container mx-auto max-w-4xl">
            <div className="w-full space-y-4">
              <PublicAboutDisplay />
              <PublicEducationDisplay />
              <PublicCertificatesDisplay />
              <PublicSubjectsDisplay />
              <PublicLanguagesDisplay />
            </div>
          </div>
        </div>
        <div className={"flex w-full flex-col gap-4 sm:min-w-[23rem] lg:w-[50rem] xl:w-fit"}>
          {data.available_locales && data.available_locales.length > 1 && (
            <PublicLanguageSwitcher />
          )}
          {data?.about_section.youtube_url && (
            <PublicYoutubePreview videoUrl={data.about_section.youtube_url} />
          )}
          <PublicReviewsPreview />
        </div>
      </div>
    </ScrollArea>
  );
}
